import loginComponent from './login.component';

let loginModule = angular.module('login', [
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/login');

    $stateProvider
      .state('login', {
        url: '/login',
        component: 'login',
        data: {
          requireLogin: false
        }
      });
  })

  .component('login', loginComponent)

  .name;

export default loginModule;


// WEBPACK FOOTER //
// ./client/app/components/login/login.js